module.exports = __webpack_public_path__ + "assets/img/Deauville_002.653d9792.jpg";